<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="配置角色排序"
        width="800px"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose">
        <div class="content-box" v-loading="dataLoading">
            <draggable :list="dataList" ghost-class="drag-ghost" group="field">
                <el-tag class="drag-item" v-for="item in dataList" :key="item.id">{{item.role_name}}</el-tag>
            </draggable>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :disabled="dataLoading" :loading="submitLoading" class="action-btn ml20">保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import Draggable from 'vuedraggable';
    import API from '@/api/role';

    export default {
        name: "RoleSortModal",
        components:{
            Draggable,
        },
        props:{
        },
        data() {
            return {
                dialogVisible: false,
                dataList:[],
                dataLoading:false,
                submitLoading:false,
            }
        },
        computed: {},
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.dataList = [];
                this.submitLoading = false;
                this.dataLoading = false;
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.getRoleList();
                });
            },
            handleSubmit(){
                if(this.dataLoading) return;
                if(this.dataList.length<=0) return;
                this.submitLoading = true;
                API.setRoleOrder({
                    role_ids:this.dataList.map(item=>item.id).join(','),
                }).then(res => {
                    console.log('setRoleOrder',res);
                    this.$message.success(res.info||'操作成功');
                    this.submitLoading = false;
                    this.$emit('update');
                    this.handleClose();
                }, (err) => {
                    console.log('getAllRoleList error', err);
                    this.$message.error(err.info||'请求失败');
                    this.submitLoading = false;
                });
            },
            getRoleList(){
                this.dataLoading = true;
                API.getAllRoleList().then(res => {
                    let resData = res.data||[];
                    console.log('getAllRoleList',res,resData);
                    this.dataList =resData;
                    this.dataLoading = false;
                }, (err) => {
                    console.log('getAllRoleList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    ::v-deep .el-dialog__body{
        /*padding-top: 5px;*/
    }

    .content-box{
        min-height: 150px;
        padding: 20px;
        background-color: #f8f8f9;
        border-radius: 5px;
        border: dashed 1px #dcdee2;
    }

    .drag-item{
        margin: 3px 6px;
        cursor: pointer;
    }

    .drag-ghost{
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }
</style>
